import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import {ca} from "date-fns/locale";

export default class TabsBehaviour extends AbstractDataAttributeBehaviour {

    attrNames = {
        'container': 'data-tabs',
        'tab': 'data-tabs-tab',
        'content': 'data-tabs-content',
    };

    querySelectors = {
        'container': `[${this.attrNames.container}]`,
        'tabs': `[${this.attrNames.tab}]`,
        'activeTab': `[${this.attrNames.tab}].is-active`,
    };

    getContainerSelector() {
        return this.querySelectors.container;
    }

    addClickHandler(container, tab) {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleTabChange(container, tab);
        });
    }

    getTabs(container) {
        return container.querySelectorAll(this.querySelectors.tabs);
    }

    getActiveTab(container) {
        return container.querySelector(this.querySelectors.activeTab);
    }

    getTabLink(tab) {
        return tab.getAttribute(this.attrNames.tab);
    }

    getTabContent(container, tab) {
        return container.querySelector(this.getTabLink(tab));
    }

    handleTabChange(container, tab) {
        let activeClass = 'is-active';
        let targetContent = this.getTabContent(container, tab);

        let oldTab = this.getActiveTab(container);
        let oldTargetContent = this.getTabContent(container, oldTab);

        oldTab.classList.remove(activeClass);
        oldTab.setAttribute('aria-selected', 'false');
        oldTargetContent.classList.remove(activeClass);
        oldTargetContent.setAttribute('aria-hidden', 'true');

        tab.classList.add(activeClass);
        tab.setAttribute('aria-selected', 'true');
        targetContent.classList.add(activeClass);
        targetContent.setAttribute('aria-hidden', 'false');

        Object.keys(this.onChangeCallbacks).forEach(key=>{
            this.onChangeCallbacks[key]();
        })
    }

    initContainer(container) {
        this.element = container;
        let tabs = this.getTabs(container);

        for (let i = 0; i < tabs.length; i++) {
            this.addClickHandler(container, tabs[i]);
        }

    }
}